import { Component } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import BCService from "../../../services/BC";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SalesService from "../../../services/SellingService";
class PayementTotalBillEnLigne extends Component {
  state = {
    numeroCard: "",
    amount: "",
    amountMax: "",
    selectedFile: null,
    urlFile: "",
    loading: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      numeroCard: "",
      amount: this.props.restToPay,
      amountMax: "",
      selectedFile: null,
      urlFile: "",
      loading: false,
    };
    this.changeNumeroCarte = this.changeNumeroCarte.bind(this);
    this.changeAmount = this.changeAmount.bind(this);
  }

  changeNumeroCarte(event) {
    this.setState({ numeroCard: event.target.value });
    console.log("numeroCard", this.state.numeroCard);
  }

  onFileChangeHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      loaded: 0,
    });
  };
  UploadFile = () => {
    const dataFile = new FormData();
    dataFile.append("file", this.state.selectedFile);

    // original UploadFileService.uploadFileBill(dataFile).then((res) => {
    //   console.log("name File image", res.data["Bill"]);
    //   this.setState({
    //     urlFile: res.data["Bill"],
    //   });

    //   console.log(res.statusText);
    // });
  };

  payerBill = (e) => {
    console.log(this.state.amount);
    const url = window.location.pathname.split("/")[1];
    if (url === "payerBill") {
      if (this.state.amount === "") {
        toast.error("Erreur : le champ montant  est vide");
      } else if (localStorage.getItem("banqueAccount") == null) {
        toast.error("Erreur : le champ compte bancaire est vide");
      } else {

        this.setState({loading:true})

        let payFactureOrAvance = {
          idUser: getCurrentUserId(),

          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),

          isAvanceOrTotalPayement: 1,

          typePayement: 1,
          urlFile: "any",

          ammountPayed: this.state.amount,

          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        };

        BCService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              window.location.reload(false);
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            window.location.reload(false);
          }).finally(()=>{
            this.setState({loading:false})

          });
      }
    } else {
      this.setState({loading:true})

      let payFactureOrAvance = {
        idUser: getCurrentUserId(),

        isFactureOrBDC: 1,
        idDocument: parseInt(localStorage.getItem("idBill")),

        isAvanceOrTotalPayement: 1,

        typePayement: 1,
        urlFile: "any",

        ammountPayed: this.state.amount,

        banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
      };

      SalesService.payFactureOrBDC(payFactureOrAvance)
        .then((response) => {
          if (response.data["error"]) {
            toast.error("Error : il ya un probléme");
          } else {
            toast.success("ajouté avec succès");

            window.location.reload(false);
          }
        })
        .catch((error) => {
          toast.error("Error : il ya un probléme");

          window.location.reload(false);
        }).finally(()=>{
          this.setState({loading:false})
        });
    }
  };

  changeAmount(event) {
    // var amount = event.target.value;
    if (event.target.value > this.state.amountMax) {
      //   this.setState({ alert_message: "error" });
      // } else {
      this.setState({ amount: event.target.value });
    }
  }

  // UploadFileService.uploadFileBill(dataFile).then((res) => {
  //   console.log("name File image", res.data["Bill"]);
  //   let name = res.data["Bill"];

  //   localStorage.setItem("fileName", name);

  //   console.log(res.statusText);
  // });

  render() {
    return (
      <div className="box-body">
        <br />
        <br />
        <label>Payement En ligne </label>
        <br />
        <ToastContainer />
        <div class="row">
          <div class="col-md-3">
            <label>Montant : </label>
            <input
              disabled
              class="form-control"
              placeholder="Montant "
              name="amount"
              value={this.props.restToPay + " DNT"}
            />
          </div>
          <div class="col-md-9">
            <label>Compte bancaire</label>
            <ListBanquesToPayement type={1} />
          </div>
        </div>
        <div class="box-footer">
          <button
            style={{ marginTop: 20 }}
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementTotalBillEnLigne;
